import { render, staticRenderFns } from "./ProjectFooter.vue?vue&type=template&id=108a6eb0&lang=pug&"
import script from "./ProjectFooter.vue?vue&type=script&lang=js&"
export * from "./ProjectFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports